export enum RoleCode {
  VIEWER = 'VIEWER',
  ADMIN = 'ADMIN',
  SUPER_USER = 'SUPER_USER',
  FILM_MAKER = 'FILM_MAKER',
}

